"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireWildcard(require("@pds-react/icon"));

var _excluded = ["as", "href", "active", "header", "icon", "borderType", "ctaPosition", "spacing", "className", "children", "square", "tocVariation"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line max-lines-per-function, max-statements
var Card = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var as = props.as,
      href = props.href,
      active = props.active,
      header = props.header,
      icon = props.icon,
      borderType = props.borderType,
      ctaPosition = props.ctaPosition,
      spacing = props.spacing,
      className = props.className,
      children = props.children,
      square = props.square,
      tocVariation = props.tocVariation,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      expand = _useState2[0],
      setExpand = _useState2[1];

  var cardRef = (0, _react.useRef)();
  var isomorphic = typeof window === "undefined";
  var useIsomorphicLayoutEffect = isomorphic ? _react.useEffect : _react.useLayoutEffect;
  useIsomorphicLayoutEffect(function () {
    var handleResize = function handleResize() {
      if (cardRef.current) {
        var card = cardRef.current;
        var cardParent = cardRef.current.parentNode;
        var difference = cardParent.clientWidth - card.clientWidth;
        setExpand(difference > 79 || card.clientWidth > 397);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  (0, _react.useImperativeHandle)(ref, function () {
    return _objectSpread({}, cardRef.current);
  }, [cardRef]);
  var classes = (0, _classnames["default"])(className, "pds-card", {
    "pds-card-toc": tocVariation === "toc"
  }, {
    "pds-card-quickLinks": tocVariation === "quickLinks"
  }, _defineProperty({}, "pds-card-visual-".concat(header), header === "header-alt"), {
    "pds-card-visual-header": header,
    "pds-card-active": active
  }, {
    "pds-card-cta-right": ctaPosition === "right"
  }, {
    "pds-card-condensed": spacing === "condensed" && !active,
    "pds-card-active-condensed": spacing === "condensed" && active
  }, {
    "pds-card-no-border": borderType === "no-border"
  }, {
    expanded: expand && !square
  }, {
    "pds-card-square": square
  });
  var Component = as;

  var handleClick = function handleClick(e) {
    if (href) {
      e.preventDefault();
      window.location.href = href;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: classes,
    ref: cardRef,
    onClick: handleClick
  }, otherProps), active && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-card-active-section"
  }, !square && icon ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "pds-card-icon",
    name: icon,
    size: 40
  }) : ""), active ? /*#__PURE__*/_react["default"].cloneElement(children, {
    active: active,
    href: href,
    spacing: spacing
  }) : _react["default"].Children.toArray(children).map(function (child) {
    if (child.type.displayName === "CardSection") {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        header: header
      });
    }

    return child;
  }));
});

Card.propTypes = {
  /** Styles the card as active. */
  active: _propTypes["default"].bool,

  /** Icon for active cards. */
  // eslint-disable-next-line object-shorthand
  icon: function icon(props, propName, componentName) {
    if (props.active && !props.square && !props[propName]) {
      return new Error("".concat(propName, " is required when active is true in ").concat(componentName, "."));
    }

    return _propTypes["default"].checkPropTypes({
      icon: _icon.IconNamePropType
    }, {
      icon: props[propName]
    }, "icon", "Card");
  },

  /** Controls the border style of the card. */
  borderType: _propTypes["default"].oneOf(["no-border"]),

  /** Controls the positioning of the call-to-action button/link. */
  ctaPosition: _propTypes["default"].oneOf(["right"]),

  /** Controls the spacing (i.e. padding) inside of the card.  */
  spacing: _propTypes["default"].oneOf(["condensed"]),

  /** Changes the HTML element of the Card. */
  as: _propTypes["default"].elementType,

  /** Where the callout card will navigate to. */
  href: _propTypes["default"].string,

  /** Extra classes for the Card. */
  className: _propTypes["default"].string,

  /** The content of the Card (usually a CardSection or CardImage). */
  children: _propTypes["default"].node,

  /** Square variant of active card */
  square: _propTypes["default"].bool,

  /** header prop for visual card */
  header: _propTypes["default"].oneOf(["header", "header-alt"]),

  /** TOC variantion for card */
  tocVariation: _propTypes["default"].oneOf(["toc", "quickLinks"])
};
Card.defaultProps = {
  as: "div"
};
Card.displayName = "Card";
var _default = Card;
exports["default"] = _default;